<template>
  <section id="mapa" class="section-mapa bg-default my-0">
    <mapa v-if="!isMobile()"></mapa>
    <panel-location :mobile="true" v-else></panel-location>
  </section>
</template>

<script>
  import Mapa from '../../modules/localidades/Mapa'
  import PanelLocation from '../localidades/PanelLocations'

  export default {
    components: { PanelLocation, Mapa },
    methods: {
      isMobile() {
        return screen.width <= 760;
      }
    }
  }
</script>

<style>

  @media only screen and (max-width: 650px) {
    .section-mapa {
      height: 1305px !important;
    }
  }

  @media only screen and (max-width: 700px) {
    .section-mapa {
      height: 816px;
    }
  }

  @media only screen and (max-width: 500px) {
    .section-mapa {
      height: 1000px;
    }
  }

  @media (min-width: 768px){
    .section-mapa {
      height: auto !important;
      min-height: 660px !important;
    }
  }

</style>
